import { render, staticRenderFns } from "./transportationInvoiceForm.vue?vue&type=template&id=6a41ba82&scoped=true&"
import script from "./transportationInvoiceForm.vue?vue&type=script&lang=js&"
export * from "./transportationInvoiceForm.vue?vue&type=script&lang=js&"
import style0 from "./transportationInvoiceForm.vue?vue&type=style&index=0&id=6a41ba82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a41ba82",
  null
  
)

export default component.exports